export class ActivityReasonFilter {
    
    public RequestTypeID?: number;
    public EquipmentClassID?: number;
    public EquipmentActivityID?: number;
    public IncludeInactive?: boolean;
}

export default ActivityReasonFilter;